"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverDesktopMinWidth = exports.PopoverDesktop = void 0;
var _Popover = require("../Popover/Popover.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var popoverDesktopMinWidth = exports.popoverDesktopMinWidth = '180px';
var PopoverDesktop = exports.PopoverDesktop = (0, _styledComponents["default"])(_Popover.Popover).withConfig({
  displayName: "PopoverDesktop",
  componentId: "sc-1q89gj7-0"
})(["min-width:", ";"], popoverDesktopMinWidth);